import { track } from "@/lib/track";

export const StoreBadges = ({ idPrefix, lazy = false }) => (
  <div className="flex flex-wrap items-center gap-4">
    <a
      href="#"
      data-testid={`${idPrefix}-appstore-badge`}
      aria-label="Download on the App Store"
      onClick={() => track("badge_click", { badge: "appstore" })}
      className="transition-transform duration-300 hover:-translate-y-0.5"
    >
      <img src="/assets/appstore_badge.svg" alt="Download Veristamp on the App Store" width="144" height="48" loading={lazy ? "lazy" : "eager"} className="h-12 w-auto" />
    </a>
    <a
      href="#"
      data-testid={`${idPrefix}-playstore-badge`}
      aria-label="Get it on Google Play"
      onClick={() => track("badge_click", { badge: "playstore" })}
      className="transition-transform duration-300 hover:-translate-y-0.5"
    >
      <img src="/assets/playstore_badge.svg" alt="Get Veristamp on Google Play" width="181" height="70" loading={lazy ? "lazy" : "eager"} className="h-[70px] w-auto -my-3" />
    </a>
  </div>
);
